import template from './checklistItemsList.template.html';

export default {
  template,
  bindings: {
    checklistItems: '=',
    onEdit: '&',
    onDelete: '&',
    onToggle: '&',
    onChange: '&',
    onReady: '&'
  },
controller: class controller {
    constructor($rootScope, $filter, $mdMedia, listInstanceService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.natural = $rootScope.natural;
      ctrl.currentTimeZone = null;
      ctrl.currentDateFormat = null;
      ctrl.currentTimeFormat = null;
      ctrl.list = listInstanceService;
      ctrl.list.clear();

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = function () {
        ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
        ctrl.currentLocale = $rootScope.CurrentLocale();
        ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
        ctrl.currentTimeFormat = $rootScope.CurrentTimeFormat();

        ctrl.list.setData(ctrl.checklistItems);
        if (ctrl.checklistItems.length) {
          ctrl.list.setOrderBy('getDueDateSort()');
        } else {
          ctrl.list.setOrderBy('');
        }
        ctrl.onReady({ list: ctrl.list });
      };
      ctrl.checklistItemsEdit = function ($event, data) {
        ctrl.onEdit({ event: $event, data: data });
      };
      ctrl.checklistItemsDelete = function ($event, data) {
        ctrl.onDelete({ event: $event, data: data });
      };
      ctrl.checklistItemsToggle = function ($event, data) {
        ctrl.onToggle({ event: $event, data: data });
      };
      ctrl.select = function (data) {
        var isSelected = ctrl.list.setSelected(data);
        ctrl.onChange({ list: ctrl.list, data: data, isSelected: isSelected });
      };

      ctrl.areAllItemsSelected = function () {
        if (ctrl.checklistItems.length) {
          return _.every(ctrl.checklistItems, function (c) {
            return c.isSelected;
          });
        } else {
          return false;
        }
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {
        if (changes.checklistItems && changes.checklistItems.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
